import React from "react";
import Body from "../layouts/Body";

const FAQ = () => {
  return <Body>FAQ</Body>;
};

export default FAQ;
